import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../../includes/footer-tab"; // Adjust path
import Preloader from "../Preloader"; // Adjust path
import BackButton from "../../includes/Back_btn"; // Adjust path
import { AuthContext } from "../../context/AuthContext"; // Adjust path
import { useNavigate, Link } from "react-router-dom";
import styles from '../../assets/css/Recharge.module.css'; // Import CSS Module
import { AiOutlineHistory } from "react-icons/ai"; // History Icon

function Recharge() {
  const navigate = useNavigate();
  const { isAuthenticated, profile, AddMoney } = useContext(AuthContext);
  const [preloader, setPreloader] = useState(true);
  const [Balance, setBalance] = useState(0);
  const [Amount, setAmount] = useState("");
  const [Minimum, setMinimum] = useState(100); // Default minimum

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Toast message function
  const message = (status, text) => {
    const options = {
        position: "top-right", autoClose: 3000, hideProgressBar: false,
        closeOnClick: true, pauseOnHover: true, draggable: true,
        progress: undefined, theme: "dark", // Use dark theme
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // Fetch profile data (balance, minimum recharge)
  useEffect(() => {
    let isMounted = true;
    setPreloader(true);
    if (profile) {
        profile((response) => {
            if (!isMounted) return;
            setPreloader(false);
            if (response.status === 0) {
                message(0, response.msg || "Failed to load profile");
            } else if (response.data && response.data.length > 0) {
                setBalance(response.data[0].wallet || 0);
                // Assuming minimum recharge comes from user_Data array, index 5
                setMinimum(response.user_Data?.[5]?.minimum_recharge || 100);
            } else {
                message(0, "Profile data not found");
            }
        });
    } else {
        setPreloader(false); // Hide preloader if profile function isn't available
    }
    return () => { isMounted = false; }; // Cleanup
  }, [profile]);

  // Handle Recharge Action
  const handleRecharge = () => {
    const numericAmount = parseFloat(Amount);
    if (isNaN(numericAmount) || numericAmount < Minimum) {
      message(0, `Minimum recharge amount is ₹${Minimum}`);
      return;
    }
    setPreloader(true); // Show preloader during API call
    if (AddMoney) {
        AddMoney(numericAmount, (res) => {
            setPreloader(false); // Hide preloader after API call
            if (res.status === 0) {
                message(0, res.msg || "Recharge failed");
            } else if (res.url) {
                // Redirect to payment gateway
                window.location.href = res.url;
            } else {
                 message(0, "Invalid response from server.");
            }
        });
    } else {
        setPreloader(false);
        message(0,"Recharge function not available.");
    }
  };

  // Framer Motion variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100 } },
  };

  return (
    <>
      <Preloader status={preloader} />
      <ToastContainer /* Props remain same */ />

      {/* Use the Guruji theme container */}
      <div className={styles.rechargeContainer}>
        {!preloader && (
            <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                exit={{ opacity: 0 }}
            >
                {/* --- Header --- */}
                <motion.div className={styles.rechargeHeader} variants={itemVariants}>
                    {/* Assuming BackButton is styled or accepts className */}
                    <BackButton className={styles.backButton} />
                    <p className={styles.headerTitle}>Recharge</p>
                    {/* <Link to="/history/recharge" className={styles.historyLink} aria-label="Recharge History">
                        <AiOutlineHistory />
                    </Link> */}
                </motion.div>

                {/* --- Recharge Box --- */}
                <motion.div className={styles.rechargeBox} variants={itemVariants}>
                    {/* Logo can be added if needed */}
                    {/* <img src="/favicon.png" className={styles.rechargeLogo} alt="Logo"/> */}

                    <div className={styles.balanceDisplay}>
                        Available Balance: ₹{Balance}
                    </div>

                    <div className={styles.inputLabel}>Enter Amount (Min: ₹{Minimum})</div>
                    <div className={styles.inputContainer}>
                        <span className={styles.currencySymbol}>₹</span>
                        <input
                            type="number" // Use number type for better mobile input
                            inputMode="decimal" // Hint for numeric keyboard
                            className={styles.amountInput}
                            onInput={(event) => {
                                // Allow only numbers
                                const value = event.target.value.replace(/[^0-9]/g, '');
                                setAmount(value !== "" ? value : "");
                            }}
                            placeholder="0" // Simple placeholder
                            value={Amount}
                        />
                    </div>

                    <div className={styles.recommendedAmount}>
                        {[Minimum, 200, 500, 1000, 2000, 5000].map((value) => (
                            // Ensure Minimum is shown if it's not one of the standard values
                            (value >= Minimum || value === Minimum) &&
                            <button
                                key={value}
                                className={styles.amountButton}
                                onClick={() => setAmount(String(value))} // Set amount as string
                            >
                                ₹{value}
                            </button>
                        ))}
                    </div>

                    <div className={styles.payButtonContainer}>
                        <button className={styles.payButton} onClick={handleRecharge}>
                            PAY BY UPI
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        )}
      </div>

      {/* --- Footer --- */}
      {/* Ensure Footer component uses the correct CSS */}
      <Footer />
    </>
  );
}

export default Recharge;
